enum CURRENCY {
  EUR = '€',
  USD = '$'
}

export const GENERAL = {
  CURRENCY
};
